import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, renderKBTextarea, renderKBUserInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { api,
apiUtils } from 'app/services';
import * as actions from 'app/actions';
import { checkObject,
getEntitiesJsonArray,
objectToArray } from 'utils/kbUtil';
import {
KBInput,
KBPopover,
KBFormError,
KBButton,
KBLogoCropper,
KBSelect,
KBRadio } from
'components';
import * as constants from 'app/constants';
import * as selectors from 'app/selectors';
import { showApiError } from 'utils/feedback';

var ServiceProviderForm = class extends React.Component {constructor(props) {super(props);this.createLockdForm = this.createLockdForm.bind(this);}createLockdForm(

  model) {
    const {
      createServiceProvidersAction,
      callback,
      updateServiceProvidersAction,
      state,
      serviceProvider } =
    this.props;

    if (state == 'update') {
      return api.
      updateServiceProviders(serviceProvider.id, model).
      then(json => {
        callback && callback(getEntitiesJsonArray(json, 'serviceProviders'));
        updateServiceProvidersAction.success(json);
        KBPopover.close();
        return true;
      });
    }

    return api.createServiceProviders(model).then(json => {
      const provider = getEntitiesJsonArray(json, 'serviceProviders');
      callback && callback(provider);
      createServiceProvidersAction.success(json);
      KBPopover.close();
      this.props.routerActions.push(
      `/admin/service/provider/${provider.id}/detail?type=service`);

      return true;
    }).catch(error => {
      showApiError(error);
    });
  }render()
  {
    const {
      fields: {
        name,
        full_name,
        logo,
        cities,
        province_id,
        address,
        oneliner,
        description,
        website,
        contact_name,
        contact_phone,
        contact_email,
        contact_wechat,
        notes },

      error,
      submitting,
      handleSubmit } =
    this.props;
    let { serviceProvider, state, citiesProps, provinces, cityIds } = this.props;
    const provincesArray = objectToArray(provinces);
    let citiesPropsFilter = province_id.value ?
    citiesProps.filter(city => city.province_id == province_id.value) :
    citiesProps;
    let selectedProvince =
    provincesArray.filter(pro => pro.id === this.props.province_id) || [];
    let selectedCity =
    citiesPropsFilter.filter(city => cityIds.includes(city.id)) || [];

    var halfClass = {
      className: 'kb-form-group kb-div-c39' };


    return (
      <form onSubmit={handleSubmit(this.createLockdForm)}>
        <header className="kb-form-header">
          <h2 className="header-title">
            {state ? '修改服务商信息' : '创建服务商'}
          </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="name" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"
            isRequired={true}

            title="名称"
            fistFoucs={true} />

          </div>
          <div className="kb-row">
            <Field name="full_name" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"
            isRequired={true}

            title="全称" />

          </div>
          <div className="kb-row">
            <Field name="province_id" component={renderKBUserInput}
            title="服务省份"
            className="kb-form-group kb-form-c18 kb-form-alone"

            multi={false}
            users={provincesArray}
            placeholder="选择省份"
            selectedUsers={selectedProvince} />

          </div>
          <div className="kb-row">
            <Field name="cities" component={renderKBUserInput}
            title="服务城市"
            className="kb-form-group kb-form-c18 kb-form-alone"

            multi={true}
            placeholder="选择城市"
            users={citiesPropsFilter}
            selectedUsers={selectedCity} />

          </div>
          <div className="kb-row">
            <Field name="address" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"
            isRequired={true}
            title="地址"
            />

          </div>
          <div className="kb-row">
            <Field name="oneliner" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"
            isRequired={true}
            title="简要描述"
            />

          </div>
          <div className="kb-row">
            <Field name="description" component={renderKBTextarea}
            title="详细描述"
            className="kb-form-group kb-form-c18 kb-form-alone"
            />

          </div>
          <div className="kb-row">
            <Field name="website" component={renderKBInput}
            {...halfClass}
            className="kb-form-group kb-form-c18 kb-form-alone"
            title="网址"
            />

          </div>
          <div className="kb-row kb-form-66">
            <Field name="contact_name" component={renderKBInput}
            {...halfClass}
            title="联系人"
            isRequired={true}
            />

            <Field name="contact_phone" component={renderKBInput}
            {...halfClass}
            title="电话"
            isRequiredR={true}

            titleClass="label-rt" />

          </div>
          <div className="kb-row kb-form-66">
            <Field name="contact_email" component={renderKBInput}
            {...halfClass}
            title="邮箱"
            isRequired={true}
            />

            <Field name="contact_wechat" component={renderKBInput}
            {...halfClass}
            titleClass="label-rt"
            title="微信"
            />

          </div>
          <div className="kb-row">
            <Field name="notes" component={renderKBTextarea}
            title="备注"
            className="kb-form-group kb-form-c18 kb-form-alone"
            />

          </div>
          <div className="kb-row" style={{ paddingBottom: 30 }}>
            <KBLogoCropper
            aspect={1}
            className="kb-form-group kb-form-c18 kb-form-alone"
            field={logo}
            bucket={'common'}
            obj={serviceProvider}
            isRequired={true}
            type="serviceProviders"
            accept="image/*" />

            {logo.touched && logo.error &&
            <p className="lr-error">{logo.error}</p>}

          </div>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const citiesProps = selectors.getCitiesToArray(state);
  const provinces = selectors.getProvinces(state);
  const { serviceProvider } = props;
  let cityIds = [];
  let province_id =
  serviceProvider &&
  serviceProvider.cities &&
  serviceProvider.cities[0] &&
  serviceProvider.cities[0].province_id;
  serviceProvider &&
  serviceProvider.cities &&
  serviceProvider.cities.map(city => {
    cityIds.push(city.id);
    return city;
  });
  return {
    citiesProps,
    provinces,
    cityIds,
    province_id };

}

function mapDispatchToProps(dispatch) {
  return {
    createServiceProvidersAction: bindActionCreators(
    actions.serviceProvidersAction.create,
    dispatch),

    updateServiceProvidersAction: bindActionCreators(
    actions.serviceProvidersAction.update,
    dispatch),

    routerActions: bindActionCreators(routerActions, dispatch) };

}

const validate = values => {
  const errors = {};

  if (valid.required(values.name)) {
    errors.name = '请输入名称';
  }

  if (valid.required(values.full_name)) {
    errors.full_name = '请输入全称';
  }

  if (valid.required(values.logo)) {
    errors.logo = '请输入Logo';
  }

  if (valid.required(values.address)) {
    errors.address = '请输入物理地址';
  }

  if (valid.required(values.oneliner)) {
    errors.oneliner = '请输入简要描述';
  }

  if (valid.required(values.contact_name)) {
    errors.contact_name = '请输入联系人';
  }

  if (valid.required(values.contact_phone)) {
    errors.contact_phone = '请输入联系电话';
  } else if (valid.commonPhoneNumber(values.contact_phone)) {
    errors.contact_phone = '请输入正确的联系电话';
  }

  if (valid.required(values.contact_email)) {
    errors.contact_email = '请输入邮箱';
  } else if (valid.email(values.contact_email)) {
    errors.contact_email = '请输入正确的邮箱';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "name",
  "full_name",
  "logo",
  "cities",
  "province_id",
  "address",
  "oneliner",
  "description",
  "website",
  "contact_name",
  "contact_phone",
  "contact_email",
  "contact_wechat",
  "notes"
];

const formConfig = {
  form: 'ServiceProviderForm',

  validate: validate,
  touchOnBlur: false };


ServiceProviderForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('ServiceProviderForm', LEGACY_FORM_FIELDS)(ServiceProviderForm)));

export default ServiceProviderForm;
